module.exports = __webpack_public_path__ + "img/google-img.1450b9f5.png";